import Header from "../components/Header";
import Footer from "../components/Footer";
import SEOHead from "../components/SEOHead";

const policies = [
  {
    title: "Information we collect",
    body: "We may collect account details, contact information, billing details, usage analytics, and content you submit when using the platform.",
  },
  {
    title: "How we use information",
    body: "Information is used to provide the service, process payments, improve product quality, send important notifications, and support customers.",
  },
  {
    title: "Sharing",
    body: "We do not sell personal information. We may share data with service providers that help us operate the platform or when required by law.",
  },
  {
    title: "Cookies and analytics",
    body: "We use cookies and similar technologies to keep you signed in, understand product usage, and improve performance.",
  },
  {
    title: "Data retention",
    body: "We retain data for as long as needed to provide the service, comply with legal obligations, resolve disputes, and enforce agreements.",
  },
  {
    title: "Your choices",
    body: "You can request access, correction, or deletion of your data by contacting our team. Some information may be retained where required by law.",
  },
  {
    title: "Contact",
    body: "Privacy requests can be sent to sales@maxemployee.com with the subject line 'Privacy Request'.",
  },
];

export default function Privacy() {
  return (
    <>
      <SEOHead
        title="Privacy Policy | Max Employee"
        description="Read the Max Employee Privacy Policy, including what data we collect, how we use it, and your choices."
        url="/privacy"
      />
      <Header />
      <main id="main-content" className="min-h-screen bg-[#09090B] text-white">
        <section className="border-b border-zinc-900 bg-gradient-to-b from-amber-500/5 to-transparent">
          <div className="max-w-5xl mx-auto px-6 lg:px-12 py-20 lg:py-24">
            <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-amber-500 mb-4">// LEGAL</p>
            <h1 className="font-display text-4xl lg:text-6xl uppercase tracking-tight leading-tight mb-6">
              Privacy Policy
            </h1>
            <p className="text-zinc-400 max-w-2xl text-lg leading-relaxed">
              This policy explains how Max Employee collects, uses, stores, and protects information when you use our website and products.
            </p>
          </div>
        </section>

        <section className="max-w-5xl mx-auto px-6 lg:px-12 py-16">
          <div className="space-y-6">
            {policies.map((section) => (
              <article key={section.title} className="border border-zinc-900 rounded-2xl bg-zinc-950/60 p-6 lg:p-8">
                <h2 className="font-display text-2xl uppercase mb-3 text-amber-500">{section.title}</h2>
                <p className="text-zinc-300 leading-relaxed">{section.body}</p>
              </article>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
